import Footer from "../components/Footer";
import {Link} from "react-router-dom";
import React, {useState} from "react";

import MetaComponent from "../components/MetaComponent";
import Header from "../components/Header";
import Features from "../home/Features";
import Category from "./Category";

const metadata = {
    title: `Categories || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function CategoryListPage({onPageReady}) {

    const [ready, setReady] = useState(false);
    return (
        <>
            <MetaComponent meta={metadata}/>
            <Header/>
            <>
                {/* Breadcrumb */}
                <div className="tf-breadcrumb space-t">
                    <div className="container">
                        <ul className="breadcrumb-list">
                            <li className="item-breadcrumb">
                                <Link to={`/`} className="text">
                                    Home
                                </Link>
                            </li>
                            <li className="item-breadcrumb dot">
                                <span/>
                            </li>
                            <li className="item-breadcrumb">
                                <span className="text">Categories</span>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* /Breadcrumb */}
                {/* Title Page */}
                <section className="page-title flat-spacing-4 pt-0">
                    <div className="container">
                        <div className="box-title text-center">
                            <h4 className="title">Categories</h4>
                            <p className="text-main text-md">
                                Effortless, elevated, and made for today. Explore a category where each piece does more
                                than look good.
                            </p>
                        </div>
                    </div>
                </section>
            </>
            <Category
                onLoaded={() => {
                    if (!ready) {
                        setReady(true);
                        onPageReady?.();
                    }
                }}
            />
            <Features/>
            <Footer/>
        </>
    );
}
